// extracted by mini-css-extract-plugin
export default {"item":"Item_item__BVw8t","active":"Item_active__s-fGa","head":"Item_head__QW91G","body":"Item_body__nL7jG","button":"Item_button__PTmsF"};